module.exports = ".row {\n  margin: 6px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/payment-history/payment-detail-dialog/payment-detail-dialog.component.css
// module id = ./src/app/user/payment-history/payment-detail-dialog/payment-detail-dialog.component.css
// module chunks = main